/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gpa_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The standard US 4.0 scale, where A = 4.0 down to F = 0, with pluses and minuses adjusting by 0.3.`)
};

const es_gpa_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La escala estándar estadounidense de 4.0, donde A = 4.0 hasta F = 0, con los signos más y menos ajustando en 0.3.`)
};

const de_gpa_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die gängige US-4,0-Skala, bei der A = 4,0 bis F = 0 reicht, wobei Plus und Minus jeweils 0,3 anpassen.`)
};

const nl_gpa_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De standaard Amerikaanse schaal van 4,0, waarbij A = 4,0 aflopend naar F = 0, met plussen en minnen die 0,3 bijstellen.`)
};

const fr_gpa_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'échelle américaine standard de 4,0, où A = 4,0 jusqu'à F = 0, les plus et moins ajustant de 0,3.`)
};

const it_gpa_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La scala standard statunitense 4.0, dove A = 4.0 fino a F = 0, con più e meno che modificano di 0,3.`)
};

const pt_br2_gpa_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A escala americana padrão de 4,0, em que A = 4,0 até F = 0, com mais e menos ajustando em 0,3.`)
};

const pt_gpa_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A escala americana padrão de 4,0, onde A = 4,0 até F = 0, com os sinais de mais e menos a ajustar em 0,3.`)
};

const ja_gpa_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`米国標準の4.0スケールで、A = 4.0からF = 0まであり、プラス・マイナスで0.3ずつ調整されます。`)
};

const zh_gpa_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`标准的美国 4.0 制，A = 4.0，依次递减到 F = 0，加号和减号会调整 0.3 分。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const gpa_faq_a2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.gpa_faq_a2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("gpa_faq_a2", locale)
	if (locale === "en") return en_gpa_faq_a2(inputs)
	if (locale === "es") return es_gpa_faq_a2(inputs)
	if (locale === "de") return de_gpa_faq_a2(inputs)
	if (locale === "nl") return nl_gpa_faq_a2(inputs)
	if (locale === "fr") return fr_gpa_faq_a2(inputs)
	if (locale === "it") return it_gpa_faq_a2(inputs)
	if (locale === "pt-BR") return pt_br2_gpa_faq_a2(inputs)
	if (locale === "pt") return pt_gpa_faq_a2(inputs)
	if (locale === "ja") return ja_gpa_faq_a2(inputs)
	return zh_gpa_faq_a2(inputs)
};